import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showFrequency: false,
    triggerDate: '',
    triggerTime: '',
    frequency: '',
    startDate: '',
    endDate: '',
    frequencyData: {
        days: []
    }
};

const scheduleSlice = createSlice({
    name: 'schedule',
    initialState,
    reducers: {
        toggleFrequency: (state, action) => {
            state.showFrequency = action.payload;
        },
        setTriggerDate: (state, action) => {
            state.triggerDate = action.payload;
        },
        setTriggerTime: (state, action) => {
            state.triggerTime = action.payload;
        },
        setFrequencyRedux: (state, action) => {
            state.frequency = action.payload;
            state.frequencyData.days = []; // Reset days when frequency is changed
        },
        resetFields: (state) => {
            // state.showFrequency = initialState.showFrequency;
            state.triggerDate = initialState.triggerDate;
            state.triggerTime = initialState.triggerTime;
            state.frequency = initialState.frequency;
            state.startDate = initialState.startDate;
            state.endDate = initialState.endDate;
            state.frequencyData = { ...initialState.frequencyData };
        },
        setStartDateRedux: (state, action) => {
            state.startDate = action.payload;
        },
        setEndDateRedux: (state, action) => {
            state.endDate = action.payload;
        },
        setDays: (state, action) => {
            state.frequencyData.days = action.payload;
        },
        patchScheduleData: (state, action) => {
            Object.assign(state, action.payload); // Merge payload with state
        },
        resetStateSchedule: () => initialState
    }
});

export const {
    toggleFrequency,
    setTriggerDate,
    setTriggerTime,
    setFrequencyRedux,
    resetFields,
    setStartDateRedux,
    setEndDateRedux,
    setDays,
    patchScheduleData,
    resetStateSchedule
} = scheduleSlice.actions;

export default scheduleSlice.reducer;
